import { render, staticRenderFns } from "./UsersLocalAssignModal.vue?vue&type=template&id=066ad84f&scoped=true"
import script from "./UsersLocalAssignModal.vue?vue&type=script&lang=js"
export * from "./UsersLocalAssignModal.vue?vue&type=script&lang=js"
import style0 from "./UsersLocalAssignModal.vue?vue&type=style&index=0&id=066ad84f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ad84f",
  null
  
)

export default component.exports